export function HelpIcon({
  notifications,
  ...props
}: React.HTMLAttributes<SVGSVGElement> & {
  notifications?: boolean;
}) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Icon is used with aria-label on parent button
    <svg
      width="42"
      height="42"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
      className="text-white hover:text-brand"
    >
      <path
        d="M26.5625 16C26.5625 10.1652 21.8348 5.4375 16 5.4375C10.1652 5.4375 5.4375 10.1652 5.4375 16C5.4375 21.8348 10.1652 26.5625 16 26.5625C21.8348 26.5625 26.5625 21.8348 26.5625 16ZM3 16C3 8.81953 8.81953 3 16 3C23.1805 3 29 8.81953 29 16C29 23.1805 23.1805 29 16 29C8.81953 29 3 23.1805 3 16ZM16 11.9375C15.1012 11.9375 14.375 12.6637 14.375 13.5625C14.375 14.2379 13.8316 14.7812 13.1562 14.7812C12.4809 14.7812 11.9375 14.2379 11.9375 13.5625C11.9375 11.318 13.7555 9.5 16 9.5C18.2445 9.5 20.0625 11.318 20.0625 13.5625C20.0625 15.9594 18.2344 16.975 17.2188 17.3457V17.5387C17.2188 18.2141 16.6754 18.7574 16 18.7574C15.3246 18.7574 14.7812 18.2141 14.7812 17.5387V17.1273C14.7812 16.0863 15.5328 15.3398 16.3098 15.0859C16.6348 14.9793 16.9801 14.8066 17.234 14.5629C17.4523 14.3496 17.625 14.0551 17.625 13.5676C17.625 12.6688 16.8988 11.9426 16 11.9426V11.9375ZM14.375 21.6875C14.375 20.7887 15.1012 20.0625 16 20.0625C16.8988 20.0625 17.625 20.7887 17.625 21.6875C17.625 22.5863 16.8988 23.3125 16 23.3125C15.1012 23.3125 14.375 22.5863 14.375 21.6875Z"
        fill="currentColor"
      />
      {notifications && <circle cx="24" cy="7" r="5.5" fill="var(--color-brand)" />}
    </svg>
  );
}
